export const domainUrl = (window as any)?.ENV_CONFIG?.API_URL;
export const minIoUrl = (window as any)?.ENV_CONFIG?.MINIO_URL;
// export const domainUrl = "https://erp.rasoft.az/app/";
// export const minIoUrl = "https://minio.rasoft.az/";

//microservice name
export const erpService = 'erp-service/';
export const ratechEnumService = `${erpService}Enums/getByName/`;
const erpServiceEnumRoot = `${erpService}Enums/getByName/com.ratech.erp.api.enums`;
const erpServiceCoreEnumRoot = `${erpService}Enums/getByName/com.ratech.erp.core.data.enums`;
const coreServiceEnumRoot = `${erpService}Enums/getByName/com.ratech.erp.core.data.enums`;
const coreSharedEnumRoot = `${erpService}Enums/getByName/com.ratech.erp.core.shared.enums`;

export const apiUrl = {
    yonetim: {
        application: `${erpService}Management/Application/`,
        barcodeTemplate: `${erpService}Management/BarcodeTemplate/`,
        dil: `${erpService}Management/Localization/`,
        eMailApi: `${erpService}Management/EMailApi/`,
        eyalet: `${erpService}Management/State/`,
        il: `${erpService}Management/Province/`,
        ilce: `${erpService}Management/District/`,
        kimlik: `${erpService}Management/Identity/`,
        organization: `${erpService}Management/Organization/`,
        bina: `${erpService}Management/Organization/Facility/`,
        roleGroup: `${erpService}Management/RoleGroup/`,
        smsApi: `${erpService}Management/SmsApi/`,
        tools: `${erpService}Management/Tools/`,
        ulke: `${erpService}Management/Country/`,
        kullanici: `${erpService}Management/User/`,
        kullaniciYetki: `${erpService}Management/UserPermission/`,
        kullaniciVeriYetki: `${erpService}Management/UserEntryPermission/`,
        system: `${erpService}Management/System/`,
        veriYetki: `${erpService}Management/UserEntryPermission/`,
        translation: `${erpService}Management/Translation/`,
        report: `${erpService}Management/Report/`,
        reportDesign: `${erpService}Management/ReportDesign/`,
        reportDesignDetail: `${erpService}Management/ReportDesign/Detail/`,
        reportDesignParameter: `${erpService}Management/ReportDesign/Parameter/`,
        reportDesignField: `${erpService}Management/ReportDesign/Field/`,
        reportDesignFile: `${erpService}Management/ReportDesignFile/`,
        dynamicQueryGroup: `${erpService}Management/DynamicQueryGroup/`,
        dynamicQuery: `${erpService}Management/DynamicQuery/`,
        dynamicQueryField: `${erpService}Management/DynamicQuery/Field/`,
        dynamicQueryCriteria: `${erpService}Management/DynamicQuery/Criteria/`,
        printer: `${erpService}Management/Printer/`,
        attachment: `Management/Attachment/`,
        userMessage: `${erpService}Management/UserMessage/`,
        printLog: `${erpService}Management/PrintLog/`,
        serverProgress: `${erpService}Management/ProcessProgress/`,
        systemParameter: `${erpService}Management/SystemParameter/`,
        exchangeRate: `${erpService}Management/ExchangeRate/`,


    },
    tanimlar: {
        birim: `${erpService}Tanim/Birim/`,
        proje: `${erpService}Tanim/Proje/`,
        eFaturaAyar: `${erpService}Tanim/EFaturaAyar/`,
        // rapor paketleri (tanım ekranı + yazdırma noktaları; bkz. core/components/print/raporPaketi)
        raporPaketi: `${erpService}Tanim/RaporPaketi/`,
        // özel raporlar (rapor tasarımcısı; bkz. core/components/print/raporTasarim)
        ozelRapor: `${erpService}RaporTasarim/OzelRapor/`,
        kimlik: `${erpService}Kimlik/`,
        kurum: `${erpService}Tanim/Kurum/`,
        kurumGrup: `${erpService}Tanim/Kurum/Grup/`,
        personel: `${erpService}Tanim/Personel/`,
        personelUnvan: `${erpService}Tanim/Unvan/`,
        personelMezuniyet: `${erpService}Tanim/Personel/Mezuniyet/`,
        sablon: `${erpService}Tanim/Sablon/`,
        kalemTuru: `${erpService}Tanim/KalemTuru/`,
        kasaOturum: `${erpService}Satis/KasaOturum/`,
        marka: `${erpService}Tanim/Marka/`,
        olcuBirim: `${erpService}Tanim/OlcuBirim/`,
        kalem: `${erpService}Tanim/Kalem/`,
        anlasma: `${erpService}Tanim/Anlasma/`,
        anlasmaDetay: `${erpService}Tanim/AnlasmaDetay/`,
        eFaturaMuafiyet: `${erpService}Tanim/EFaturaMuafiyet/`,
        eFaturaTevkifat: `${erpService}Tanim/EFaturaTevkifat/`,
        kurumFaturaParametre: `${erpService}Tanim/KurumFaturaParametre/`,
        hesapPlan: `${erpService}Tanim/HesapPlan/`,
        hesapPlanDonem: `${erpService}Tanim/HesapPlanDonem/`,
        bolge: `${erpService}Tanim/Bolge/Bolge/`,
        masa: `${erpService}Tanim/Bolge/Masa/`
    },
    ihale: {
        kayit: `${erpService}Ihale/`,
        kalem: `${erpService}Ihale/Kalem/`,
        evrak: `${erpService}Ihale/Evrak/`,
        tedarikci: `${erpService}Ihale/Tedarikci/`,
        tedarikciKalem: `${erpService}Ihale/TedarikciKalem/`,
        ihaleTeklif: `${erpService}Ihale/Teklif/`,
        ihaleTeklifKalem: `${erpService}Ihale/TeklifKalem/`,
        topluAlimKurum: `${erpService}Ihale/TopluAlimKurum/`,
        topluAlimKurumKalem: `${erpService}Ihale/TopluAlimKurumKalem/`,
        // girişsiz (tedarikçinin teklif sayfası; IhaleTedarikciRs'in @PermitAll uçları); girişli link uçları tedarikci + "teklifLinki/…"
        tedarikciTeklifLinki: `${erpService}Ihale/Tedarikci/tedarikciTeklifLinki/`,
    },
    siparis: {
        kayit: `${erpService}Siparis/`,
        kalem: `${erpService}Siparis/Kalem/`,
    },
    satis: {
        satis: `${erpService}Satis/Satis/`,
        // arka uç SatisDetayRs @Path("/Satis/Detay")
        satisDetay: `${erpService}Satis/Detay/`,
        // 18.10.2026 satış / restoran işi (SOZLESME §4): uç yolları sözleşmededir
        kasaOturum: `${erpService}Satis/KasaOturum/`,
        kasaHareket: `${erpService}Satis/KasaHareket/`,
        // ---- G5 çatı kalıbı göçü (22.10.2026): ekran uçları ilgili varlığın Rs'inde (SatisRs / SatisDetayRs / QrMenuAyarRs)
        restoran: `${erpService}Satis/Satis/restoran/`,
        mutfak: `${erpService}Satis/Detay/mutfak/`,
        satisRapor: `${erpService}Satis/Satis/satisRapor/`,
        satisFatura: `${erpService}Satis/Satis/satisFatura/`,
        qrMenu: `${erpService}Satis/QrMenu/`,
        // girişsiz QR menü sayfasının ucu (/qr-menu#<anahtar> arayüz rotası değişmez; API @PermitAll)
        qrMenuAcik: `${erpService}Satis/QrMenu/acik/`,
        // ürün reçetesi CRUD + urunReceteleri/{urunKalemId} (Kalem ekranı reçete sekmesi). tanimlar'a EKLENMEDİ:
        // tanimlar tipinin metni temel tsc hatalarında basılıyor, yeni anahtar sahte "YENI" satırları doğurur
        kalemRecete: `${erpService}Tanim/KalemRecete/`,
    },
    dashboard: {
        dashboard: `${erpService}Dashboard/`,
    },

    auth: {
        userLogin: `${erpService}Auth/UserLogin/`,
        // oturumdaki kullanıcının kişisel tercihleri (Görünüm; KullaniciTercihRs): benim/{tur}, benimKaydet.
        // tanimlar / yonetim'e EKLENMEDİ: o tiplerin metni temel tsc hatalarında basılıyor, yeni anahtar sahte "YENI" doğurur
        kullaniciTercih: `${erpService}Tanim/KullaniciTercih/`,
    },

    stok: {
        // ---- G2 çatı kalıbı göçü: StokHareketDetayBarkodRs ek uçları (eski /Stok/BarkodTakip, /Stok/HareketBarkod) ----
        barkodTakip: `${erpService}Stok/StokHareketDetayBarkod/barkodTakip/`,
        hareketBarkod: `${erpService}Stok/StokHareketDetayBarkod/hareketBarkod/`,
        tanimlar: {
            etkenMadde: `${erpService}Tanim/Stok/EtkenMadde/`,
            malzemeOlcuBirim: `${erpService}Tanim/Stok/MalzemeOlcuBirim/`,
            olcuBirim: `${erpService}Tanim/OlcuBirim/`,
            malzemeDepoDetay: `${erpService}Tanim/Stok/MalzemeDepoDetay/`,
        },
        stokHareket: `${erpService}Stok/StokHareket/`,
        stokHareketDetay: `${erpService}Stok/StokHareketDetay/`,
        stokHareketDosya: `${erpService}Stok/StokHareket/Dosya/`,
        stokTalep: `${erpService}Stok/StokTalep/`,
        stokTalepDetay: `${erpService}Stok/StokTalepDetay/`,
        stokAtik: `${erpService}Stok/StokAtik/`,
        stokIade: `${erpService}Stok/StokIade/`,
        malzemeDepoDurum: `${erpService}Stok/MalzemeDepoDurum/`,
        // ---- stok-sayim ---- Stok › Stok Sayım (form 3-21)
        stokSayim: `${erpService}Stok/StokSayim/`,
    },

    fatura: {
        fatura: `${erpService}Fatura/`,
        faturaDetay: `${erpService}Fatura/Detay/`,
        gelenEFatura: `${erpService}EFatura/`,
        // giden e-fatura listesi (sağlayıcıdaki giden e-Fatura / e-Arşiv): getList, esitlemeDurumu, saglayicidanAl, detay/{id},
        // eBelgeGoruntu/{id}, eBelgeXml/{id}, aktarimOnizleme/{id}, ratecheAktar, topluRatecheAktar, kalemBirimleri/{kalemId}
        gidenEFatura: `${erpService}GidenEFatura/`,
        cariBelge: `${erpService}Fatura/CariBelge/`,
        // satır barkodları (seçim / okutma / iade karekodları); çatı kalıbı göçü: FaturaDetayRs ek uçları
        barkod: `${erpService}Fatura/Detay/barkod/`,
        // faturanın iç ekleri (belge penceresi "Ekler"; e-faturaya gönderilmez)
        ek: `${erpService}Fatura/Ek/`,
        // gelen e-İrsaliye listesi / eşitleme / alış irsaliyesine dönüştürme ve gelen faturanın irsaliyeye bağlanması
        // G2 çatı kalıbı göçü: EFaturaRs ek ucu (eski /GelenEIrsaliye)
        gelenEIrsaliye: `${erpService}EFatura/gelenEIrsaliye/`,
        // belge satırı fiyat önerisi (ihale teklifi, son satış / alış, kart fiyatı); çatı kalıbı göçü: FaturaRs ek ucu
        fiyatOnerisi: `${erpService}Fatura/fiyatOnerisi/`,
        // ÜTS (TİTCK Ürün Takip Sistemi): ayar (Tanımlar > ÜTS Ayarları — tanimlar'a EKLENMEDİ, tsc temel çizgi tuzağı),
        // sorgu ve kabul (Fatura > ÜTS Sorgu ve Kabul), bildirimler (Fatura > ÜTS Bildirimleri), Rev 1.99 yeni servisler
        // (utsAkis: bildirim ayrıntısı, ürün kaydı, almak istemiyorum, eksik alma — Sorgu ekranının 5-6 yetkileriyle)
        // ---- ÜTS (G6 çatı kalıbı göçü) ---- sorgu ve akış uçları UtsBildirimRs'in ek uçları (eski Fatura/Uts/Sorgu, Fatura/Uts/Akis)
        utsAyar: `${erpService}Tanim/UtsAyar/`,
        utsSorgu: `${erpService}Fatura/Uts/Bildirim/utsSorgu/`,
        utsBildirim: `${erpService}Fatura/Uts/Bildirim/`,
        utsAkis: `${erpService}Fatura/Uts/Bildirim/utsAkis/`,
        // ---- 21.10.2026 muhasebe / e-belge işi (SOZLESME §2.8) ----
        // gelen e-fatura kabulünü / gelen iade eşleştirmesini geri alma (H5, form 5-7)
        // G2 çatı kalıbı göçü: EFaturaRs ek ucu (eski /GelenKabul)
        gelenKabul: `${erpService}EFatura/gelenKabul/`,
        // e-İrsaliye yanıtı (gelen irsaliyeye kabul / red / kısmi; giden irsaliyenin alınan yanıtları) ve toplu gönderim (H6)
        eIrsaliyeYanit: `${erpService}EIrsaliyeYanit/`,
        // ---- G1a çatı kalıbı göçü: FaturaRs ek uçları (eski Fatura/TopluIrsaliye, Fatura/EBelgeOnizleme) ----
        topluIrsaliye: `${erpService}Fatura/topluIrsaliye/`,
        // gönderim öncesi önizleme, gönderilen UBL, sağlayıcı PDF'i (H7)
        eBelgeOnizleme: `${erpService}Fatura/eBelgeOnizleme/`,
        // carilerin GİB mükellefiyeti toplu güncelleme, e-Arşiv e-posta / SMS iletimi (H8)
        // çatı kalıbı göçü (G4): KurumRs ek uçları (eski Fatura/Mukellefiyet)
        mukellefiyet: `${erpService}Tanim/Kurum/mukellefiyet/`,
        earsivIletim: `${erpService}Fatura/EArsivIletim/`,
    },

    muhasebe: {
        muhasebeHareket: `${erpService}MuhasebeHareket/`,
        muhasebeHareketDetay: `${erpService}MuhasebeHareket/Detay/`,
        cariHareket: `${erpService}Muhasebe/CariHareket/`,
        // çatı kalıbı göçü (G4): kasa / banka tahsilat-ödeme MuhasebeHareketRs ek uçları
        kasaBanka: `${erpService}MuhasebeHareket/kasaBanka/`,
        cekSenet: `${erpService}Muhasebe/CekSenet/`,
        cekSenetHareket: `${erpService}Muhasebe/CekSenetHareket/`,
        // ---- çatı kalıbı göçü (G4): eski Muhasebe/Rapor uçları — cari raporları CariHareketRs'te (Excel: …/rapor/exportListToExcel),
        // Muhasebe Özet MuhasebeHareketRs'te (getOzet), cari ekstre / mutabakat e-postası CariMutabakatRs'te (cariEPosta/*) ----
        rapor: `${erpService}Muhasebe/CariHareket/rapor/`,
        muhasebeHareketRapor: `${erpService}MuhasebeHareket/rapor/`,
        cariMutabakatRapor: `${erpService}Muhasebe/CariMutabakat/rapor/`,
        // salt okunur Cari Görüntüleme (kurum kullanıcıları): getKurumList, getCariEkstre, getBelgeList, eBelgeGoruntu/{id}, eBelgeXml/{id}
        // çatı kalıbı göçü (G4): FaturaRs ek uçları (eski Muhasebe/CariGoruntuleme)
        cariGoruntuleme: `${erpService}Fatura/cariGoruntuleme/`,
        // dönem kilidi kayıtları (yalnız ekleme) + gecerli
        donemKilidi: `${erpService}Muhasebe/DonemKilidi/`,
        // mali müşavir dönem raporu: satirlar (Excel çatıdan), ozet
        // çatı kalıbı göçü (G4): FaturaRs ek uçları (Excel: …/maliMusavirRaporu/exportListToExcel)
        maliMusavirRaporu: `${erpService}Fatura/maliMusavirRaporu/`,
        // ---- 21.10.2026 muhasebe / e-belge işi (devam/muhasebe-ebelge-uygulama/SOZLESME.md §2.8) ----
        // muhasebe ayarları (get, kaydet) ve hesap eşlemeleri (H10)
        muhasebeAyar: `${erpService}Muhasebe/Ayar/`,
        hesapEsleme: `${erpService}Muhasebe/HesapEsleme/`,
        // genel muhasebe (H10): fişler, muhasebeleştirme, mizan / büyük defter / yevmiye, dönem sonu
        muhasebeFis: `${erpService}Muhasebe/Fis/`,
        // ---- G3 çatı kalıbı göçü: muhasebeleştirme / genel rapor / dönem sonu uçları MuhasebeFisRs'te; Excel
        // (exportListToExcel) muhasebeFis tabanından ----
        muhasebelestirme: `${erpService}Muhasebe/Fis/muhasebelestirme/`,
        genelMuhasebeRapor: `${erpService}Muhasebe/Fis/genelRapor/`,
        donemSonu: `${erpService}Muhasebe/Fis/donemSonu/`,
        // dış muhasebe aktarımı ve dış hesap kodu eşlemesi (H11)
        disAktarim: `${erpService}Muhasebe/DisAktarim/`,
        disHesapEsleme: `${erpService}Muhasebe/DisHesapEsleme/`,
        // kur farkı / değerleme, sabit kıymet / amortisman (H12)
        kurFarki: `${erpService}Muhasebe/KurFarki/`,
        sabitKiymet: `${erpService}Muhasebe/SabitKiymet/`,
        // ---- G3 çatı kalıbı göçü: değerleme uçları KurDegerlemeRs'te, amortisman uçları SabitKiymetRs'te ----
        kurDegerleme: `${erpService}Muhasebe/KurDegerleme/`,
        amortisman: `${erpService}Muhasebe/SabitKiymet/amortisman/`,
        // KDV1 / KDV2 özeti, Ba-Bs (H13); çatı kalıbı göçü: FaturaRs ek uçları (Excel: apiUrl.fatura.fatura + exportListToExcel)
        beyan: `${erpService}Fatura/beyan/`,
        // kasa / banka: virman, masraf ödemesi, banka ekstresi ve sütun şablonu (H9)
        // çatı kalıbı göçü (G4): virman / masraf MuhasebeHareketRs ek uçları (Excel: …/virman|masrafOdemesi/exportListToExcel)
        virman: `${erpService}MuhasebeHareket/virman/`,
        masrafOdemesi: `${erpService}MuhasebeHareket/masrafOdemesi/`,
        bankaEkstre: `${erpService}Muhasebe/BankaEkstre/`,
        bankaEkstreSablonu: `${erpService}Muhasebe/BankaEkstreSablonu/`,
        // ---- ekstre ---- otomatik kayıt kuralları (CRUD; 24.10.2026)
        bankaEkstreKurali: `${erpService}Muhasebe/BankaEkstreKurali/`,
        // cari: risk ön kontrolü, vade farkı, ödeme planı, toplu mutabakat (H3); mutabakatYanitAcik girişsiz (@PermitAll)
        // çatı kalıbı göçü (G4): risk / ödeme planı CariHareketRs ek uçları; girişsiz yanıt CariMutabakatRs ek uçları
        // (arayüz rotası /mutabakat#anahtar değişmedi)
        cariRisk: `${erpService}Muhasebe/CariHareket/cariRisk/`,
        vadeFarki: `${erpService}Muhasebe/VadeFarki/`,
        odemePlani: `${erpService}Muhasebe/CariHareket/odemePlani/`,
        cariMutabakat: `${erpService}Muhasebe/CariMutabakat/`,
        mutabakatYanitAcik: `${erpService}Muhasebe/CariMutabakat/mutabakatYanit/`,
        // ---- 23.10.2026 genel muhasebe geliştirmesi (devam/genel-muhasebe-gelistirme/SOZLESME.md §8) ----
        // kapanis / degerleme dönem sonu uçları mevcut donemSonu tabanında (yansitma…, vergi…, smm/…, reeskont/…);
        // defter-fis fiş uçları muhasebeFis tabanında (kopyala/…, tersKayit/…, iceAktar/…, yazdir/…)
        // ay-sonu: KDV mahsubu (MuhasebeFisRs ek uçları), peşin gider / gelir planları, tekrarlayan fiş şablonları
        aySonu: `${erpService}Muhasebe/Fis/aySonu/`,
        tahakkukPlani: `${erpService}Muhasebe/TahakkukPlani/`,
        // ---- donem: geçici vergi (GeciciVergiHesabiRs: durum/, hesapla/, kaydet/, fisOlustur/, geriAl/ + {yil}/{donem}) ----
        geciciVergi: `${erpService}Muhasebe/GeciciVergi/`,
        fisSablonu: `${erpService}Muhasebe/FisSablonu/`,
        // defter-fis: yevmiye defteri kesinleştirme
        defterKesinlesme: `${erpService}Muhasebe/DefterKesinlesme/`,
        // raporlar: bilanço / gelir tablosu, uyum kontrolü (MuhasebeFisRs ek uçları; Excel muhasebeFis tabanından)
        maliTablo: `${erpService}Muhasebe/Fis/maliTablo/`,
        uyumKontrolu: `${erpService}Muhasebe/Fis/uyumKontrolu/`,
        // dönem bakiyeleri (hesap planı dönem tablosu, 23.10.2026; MuhasebeFisRs ek uçları): durum, yenidenHesapla?yil=
        donemBakiye: `${erpService}Muhasebe/Fis/donemBakiye/`,
        // planlama: masraf merkezleri (+ dağılım raporu), bütçe (+ bütçe – gerçekleşen)
        masrafMerkezi: `${erpService}Muhasebe/MasrafMerkezi/`,
        butce: `${erpService}Muhasebe/Butce/`,
        // degerleme: şüpheli alacaklar
        supheliAlacak: `${erpService}Muhasebe/SupheliAlacak/`,
    },

    iletisim: {
        tanimlar: {
            interaktifSablon: `${erpService}Iletisim/Tanim/InteraktifSablon/`,
            interaktifSablonDetay: `${erpService}Iletisim/Tanim/InteraktifSablon/Detay/`,
        }
    },

    klinikMuhendislik: {
        cihaz: {
            tanimlar: {
                cihaz: `${erpService}KlinikMuhendislik/Tanim/Cihaz/`,
            },
            cihazDosya: `${erpService}KlinikMuhendislik/Cihaz/CihazDosya/`,
            cihazBakim: `${erpService}KlinikMuhendislik/Cihaz/CihazBakim/`,
            cihazBakimPeriyot: `${erpService}KlinikMuhendislik/Cihaz/CihazBakim/Periyot/`,
            cihazBakimDosya: `${erpService}KlinikMuhendislik/Cihaz/CihazBakimDosya/`,
            cihazZimmet: `${erpService}KlinikMuhendislik/Cihaz/Zimmet/`,
            cihazBakimPeriyotMalzeme: `${erpService}KlinikMuhendislik/Cihaz/CihazBakim/Periyot/Malzeme/`,
            cihazBakimPeriyotDosya: `${erpService}KlinikMuhendislik/Cihaz/CihazBakim/Periyot/Dosya/`,
            cihazDowntime: `${erpService}KlinikMuhendislik/Tanim/Cihaz/cihazDowntime/`, // ---- G6 çatı göçü: CihazRs ek ucu ----
        },
        destek: {
            destekTalep: `${erpService}KlinikMuhendislik/DestekTalep/`,
            destekTalepYorum: `${erpService}KlinikMuhendislik/DestekTalep/Yorum/`,
            destekTalepCalisma: `${erpService}KlinikMuhendislik/DestekTalep/Calisma/`,
            destekTalepTakip: `${erpService}KlinikMuhendislik/DestekTalep/Takip/`,
            destekTalepHareket: `${erpService}KlinikMuhendislik/DestekTalep/Hareket/`,
            destekTalepMalzeme: `${erpService}KlinikMuhendislik/DestekTalep/Malzeme/`,
            destekTalepIstatistik: `${erpService}KlinikMuhendislik/DestekTalep/istatistik/`, // ---- G6 çatı göçü: DestekTalepRs ek ucu ----
            destekTalepDosya: `${erpService}KlinikMuhendislik/DestekTalep/Dosya/`,
        }
    },

    restoran: {
        base: `${erpService}Tanim/Bolge/Masa/`,
    },

    enums: {
        kalemGrubu: `${erpServiceEnumRoot}.KalemGrubu`,
        kalemAltGrubu: `${erpServiceEnumRoot}.KalemAltGrubu`,
        kurumTuru: `${erpServiceEnumRoot}.KurumTuru`,
        bakiyeDurumu: `${erpServiceEnumRoot}.BakiyeDurumu`,
        cariBelgeTuru: `${erpServiceEnumRoot}.CariBelgeTuru`,
        birimGrubu: `${erpServiceEnumRoot}.BirimGrubu`,
        birimAltGrubu: `${erpServiceEnumRoot}.BirimAltGrubu`,
        malzemeTuru: `${erpServiceEnumRoot}.MalzemeTuru`,
        malzemeOlcuBirimTipi: `${erpServiceEnumRoot}.MalzemeolcuBirimTipi`,
        malzemeSatisTipi: `${erpServiceEnumRoot}.MalzemeSatisTipi`,
        kurumTipi: `${erpServiceEnumRoot}.KurumTipi`,
        stokSatisHedefi: `${erpServiceEnumRoot}.StokSatisHedefi`,
        belgeTipi: `${erpServiceEnumRoot}.BelgeTipi`,
        malHizmetGorunumTipi: `${erpServiceEnumRoot}.MalHizmetGorunumTipi`,
        kurumSeriTipi: `${erpServiceEnumRoot}.KurumSeriTipi`,
        faturaKayitTipi: `${erpServiceEnumRoot}.FaturaKayitTipi`,
        faturaDurum: `${erpServiceEnumRoot}.FaturaDurum`,
        eFaturaSenaryo: `${erpServiceEnumRoot}.EFaturaSenaryo`,
        eFaturaTipi: `${erpServiceEnumRoot}.EFaturaTipi`,
        eFaturaDurum: `${erpServiceEnumRoot}.EFaturaDurum`,
        eBelgeKanali: `${erpServiceEnumRoot}.EBelgeKanali`,
        raporPaketiBaglami: `${erpServiceEnumRoot}.RaporPaketiBaglami`,
        eFaturaIntegrationProvider: `${erpServiceEnumRoot}.EFaturaIntegrationProvider`,
        stokHareketSekli: `${erpServiceEnumRoot}.StokHareketSekli`,
        stokKayitDurumu: `${erpServiceEnumRoot}.StokHareketKayitDurumu`,
        stokTalepDurumu: `${erpServiceEnumRoot}.StokTalepDurumu`,
        ihaleDurumu: `${erpServiceEnumRoot}.IhaleDurumu`,
        ihaleAlimYontemi: `${erpServiceEnumRoot}.IhaleAlimYontemi`,
        ihaleTuru: `${erpServiceEnumRoot}.IhaleTuru`,
        ihaleEvrakTuru: `${erpServiceEnumRoot}.IhaleEvrakTuru`,
        ihaleHakedisYontemi: `${erpServiceEnumRoot}.IhaleHakedisYontemi`,
        ihaleTedarikciDurum: `${erpServiceEnumRoot}.IhaleTedarikciDurum`,
        tedarikciTeklifLinkiDurumu: `${erpServiceEnumRoot}.TedarikciTeklifLinkiDurumu`,
        ihaleTeklifTuru: `${erpServiceEnumRoot}.IhaleTeklifTuru`,
        hesapPlanKategori: `${erpServiceEnumRoot}.HesapPlanKategori`,
        hesapBakiyeYonu: `${erpServiceEnumRoot}.HesapBakiyeYonu`,

        //Core Enums
        requestType: `${coreServiceEnumRoot}.SmsRequestType`,
        responseType: `${coreServiceEnumRoot}.SmsResponseType`,
        barkodSablonTipi: `${coreServiceEnumRoot}.BarkodSablonTipi`,
        cinsiyet: `${coreServiceEnumRoot}.Gender`,
        printerType: `${coreServiceEnumRoot}.PrinterType`,
        barcodeCommandType: `${coreSharedEnumRoot}.BarcodeCommandType`,
        printMethod: `${coreServiceEnumRoot}.PrintMethod`,
        medeniDurum: `${coreServiceEnumRoot}.MaritalStatus`,
        httpMethod: `${coreServiceEnumRoot}.HttpMethod`,
        status: `${coreServiceEnumRoot}.Status`,
        userRole: `${coreServiceEnumRoot}.UserRole`,
        varYok: `${erpServiceEnumRoot}.VarYok`,
        yesNo: `${coreServiceEnumRoot}.YesNo`,
        reportParameterType: `${coreServiceEnumRoot}.ReportParameterType`,
        reportDesignFileType: `${coreServiceEnumRoot}.ReportDesignFileType`,
        color: `${coreServiceEnumRoot}.Color`,
        dynamicQueryFieldType: `${coreServiceEnumRoot}.DynamicQueryFieldType`,
        organizationLevel: `${coreServiceEnumRoot}.OrganizationLevel`,
        parameterValueSource: `${coreServiceEnumRoot}.ParameterValueSource`,
        weekDay: `${coreServiceEnumRoot}.WeekDay`,
        currency: `${coreServiceEnumRoot}.Currency`,
        siparisTipi: `${erpServiceEnumRoot}.SiparisTipi`,
        siparisDurumu: `${erpServiceEnumRoot}.SiparisDurumu`,
        stokHareketTipi: `${erpServiceEnumRoot}.StokHareketTipi`,
        muhasebeHareketSekli: `${erpServiceEnumRoot}.MuhasebeHareketSekli`,
        stopajTuru: `${erpServiceEnumRoot}.StopajTuru`, // ---- fatura: stopaj ----
        odemeSekli: `${erpServiceEnumRoot}.OdemeSekli`,
        cariHareketTipi: `${erpServiceEnumRoot}.CariHareketTipi`,
        cariHareketKaynakTipi: `${erpServiceEnumRoot}.CariHareketKaynakTipi`,
        finansIslemTipi: `${erpServiceEnumRoot}.FinansIslemTipi`,
        cekSenetTipi: `${erpServiceEnumRoot}.CekSenetTipi`,
        cekSenetYonu: `${erpServiceEnumRoot}.CekSenetYonu`,
        cekSenetDurumu: `${erpServiceEnumRoot}.CekSenetDurumu`,
        muhasebeHareketTipi: `${erpServiceEnumRoot}.MuhasebeHareketTipi`,
        emailSmsSablonTipi: `${coreServiceEnumRoot}.EMailSmsSablonTipi`,
        interaktifMesajTipi: `${coreServiceEnumRoot}.InteraktifMesajTipi`,
        interaktifGonderimTipi: `${coreServiceEnumRoot}.InteraktifGonderimTipi`,
        cihazDurumu: `${erpServiceEnumRoot}.CihazDurumu`,
        cihazZimmetDurumu: `${erpServiceEnumRoot}.CihazZimmetDurumu`,
        malzemeUcretDurumu: `${erpServiceEnumRoot}.MalzemeUcretDurumu`,
        cihazTipi: `${erpServiceEnumRoot}.CihazTipi`,
        sureTipi: `${erpServiceEnumRoot}.SureTipi`,
        tahsilatSekli: `${erpServiceEnumRoot}.TahsilatSekli`,
        sterilizasyonTuru: `${erpServiceEnumRoot}.SterilizasyonTuru`,
        destekTalepDurumu: `${erpServiceEnumRoot}.DestekTalepDurumu`,
        destekTipi: `${erpServiceEnumRoot}.DestekTipi`,
        oncelikDurumu: `${erpServiceEnumRoot}.OncelikDurumu`,
        destekTuru: `${erpServiceEnumRoot}.DestekTuru`,
        destekTalepHareketTipi: `${erpServiceEnumRoot}.DestekTalepHareketTipi`,
        destekTalepKanali: `${erpServiceEnumRoot}.DestekTalepKanali`,
        // satış / restoran (18.10.2026)
        satisOdemeTipi: `${erpServiceEnumRoot}.SatisOdemeTipi`,
        kasaHareketTipi: `${erpServiceEnumRoot}.KasaHareketTipi`,
        kasaOturumDurum: `${erpServiceEnumRoot}.KasaOturumDurum`,
        adisyonTipi: `${erpServiceEnumRoot}.AdisyonTipi`,
        mutfakDurumu: `${erpServiceEnumRoot}.MutfakDurumu`,
        hazirlikIstasyonu: `${erpServiceEnumRoot}.HazirlikIstasyonu`,
        iptalNedeni: `${erpServiceEnumRoot}.IptalNedeni`,
        indirimTipi: `${erpServiceEnumRoot}.IndirimTipi`,
        masaDurumu: `${erpServiceEnumRoot}.MasaDurumu`,
        // ÜTS (19.10.2026)
        utsBildirimTuru: `${erpServiceEnumRoot}.UtsBildirimTuru`,
        utsBildirimDurumu: `${erpServiceEnumRoot}.UtsBildirimDurumu`,
        utsTakipTuru: `${erpServiceEnumRoot}.UtsTakipTuru`,
        utsKaynakTuru: `${erpServiceEnumRoot}.UtsKaynakTuru`,
        utsHekTuru: `${erpServiceEnumRoot}.UtsHekTuru`,
        utsImhaGerekcesi: `${erpServiceEnumRoot}.UtsImhaGerekcesi`,
        utsCikarmaGerekcesi: `${erpServiceEnumRoot}.UtsCikarmaGerekcesi`,
        utsAlanTipi: `${erpServiceEnumRoot}.UtsAlanTipi`,
        utsAlanZorunlulugu: `${erpServiceEnumRoot}.UtsAlanZorunlulugu`,
        // muhasebe / e-belge (21.10.2026, SOZLESME §2.2)
        hesapEslemeTuru: `${erpServiceEnumRoot}.HesapEslemeTuru`,
        muhasebeFisTuru: `${erpServiceEnumRoot}.MuhasebeFisTuru`,
        muhasebeFisKaynakTipi: `${erpServiceEnumRoot}.MuhasebeFisKaynakTipi`,
        muhasebeFisDurum: `${erpServiceEnumRoot}.MuhasebeFisDurum`,
        kasaBankaKaynakTipi: `${erpServiceEnumRoot}.KasaBankaKaynakTipi`,
        faturaKurTuru: `${erpServiceEnumRoot}.FaturaKurTuru`,
        eArsivGonderimSekli: `${erpServiceEnumRoot}.EArsivGonderimSekli`,
        irsaliyeYanitTuru: `${erpServiceEnumRoot}.IrsaliyeYanitTuru`,
        irsaliyeYanitYonu: `${erpServiceEnumRoot}.IrsaliyeYanitYonu`,
        mutabakatYanitDurumu: `${erpServiceEnumRoot}.MutabakatYanitDurumu`,
        amortismanYontemi: `${erpServiceEnumRoot}.AmortismanYontemi`,
        disAktarimHedefi: `${erpServiceEnumRoot}.DisAktarimHedefi`,
        bankaEkstreSatirDurumu: `${erpServiceEnumRoot}.BankaEkstreSatirDurumu`,
        mukellefiyetDurumu: `${erpServiceEnumRoot}.MukellefiyetDurumu`,
        eArsivIletimKanali: `${erpServiceEnumRoot}.EArsivIletimKanali`,
        eArsivIletimDurumu: `${erpServiceEnumRoot}.EArsivIletimDurumu`,


    }
}
